import { TextFieldProps } from '@mui/material';
import { ChangeEvent } from 'react';
import {
  Controller,
  ControllerRenderProps,
  useFormContext,
} from 'react-hook-form';

import {
  InnerLabelTextField,
  IInnerLabelTextField,
} from '../InnerLabelTextField';

export interface IControlledTextField extends IInnerLabelTextField {
  /** The label text of the input. */
  label: string;
  /** The field name within the form. */
  fieldName: string;
  /** The input mode. */
  inputMode?: TextFieldProps['inputMode'];
  /** Prefixes the input with a dollar sign icon. */
  currencyIcon?: boolean;
  /** Informative text to be rendered inside a tooltip. */
  infoTooltipText?: string;
  /** Additional supplemental text that renders beneath the label. */
  helperText?: string;
}

export const ControlledTextField = ({
  fieldName,
  inputMode = 'text',
  ...props
}: IControlledTextField) => {
  const {
    control,
    formState: { touchedFields },
    trigger,
  } = useFormContext();

  const handleChange = (
    event: ChangeEvent<HTMLInputElement>,
    field: ControllerRenderProps
  ) => {
    field.onChange(event.target.value);
  };

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field, fieldState }) => {
        const errorMessage = fieldState.error?.message;

        return (
          <InnerLabelTextField
            {...field}
            {...props}
            errorMessage={errorMessage}
            isBlurred={touchedFields[fieldName]}
            fieldName={fieldName}
            inputMode={inputMode}
            type={inputMode}
            value={field.value || ''}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              handleChange(event, field);
            }}
            onBlur={() => {
              field.onBlur();
              trigger(fieldName);
            }}
          />
        );
      }}
      {...props}
    />
  );
};
